module.exports = fox._r("images/promo/tutor-arr.png", __webpack_public_path__ + "_/common/images/promo/tutor-arr.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/promo/tutor-arr.png
// module id = 42
// module chunks = 2